var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('poll-scores',{attrs:{"poll-chain":_vm.pollChain,"is-screen":_vm.isScreen,"module-type":_vm.moduleType}})}
var staticRenderFns = []

export { render, staticRenderFns }